import { render, staticRenderFns } from "./DataSingleRender.vue?vue&type=template&id=16b795d3&"
import script from "./DataSingleRender.vue?vue&type=script&lang=js&"
export * from "./DataSingleRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports